var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.paginasTotal > 1)?_c('ul',_vm._l((_vm.paginas),function(pagina){return _c('li',{key:pagina},[_c('router-link',{attrs:{"to":{query: _vm.query(pagina)}}},[_vm._v(" "+_vm._s(pagina)+" ")])],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }